import { type OrderDTO } from 'ecosystem'
import type { OrderProvisionResult } from '../types'
import { ingridApi } from '../../../../utils/indrid'
import { alertService } from '../../../../utils/alert-service'

export const generateIngridShippingProviderResult = async (
  orderData: OrderDTO
): Promise<OrderProvisionResult['shippingProviderResult']> => {
  if (!orderData.shippingId) {
    throw Error('Ingrid shippingId is not provided')
  }

  const { data: ingridData, error: getIngridError } = await ingridApi.checkout.getSession(
    orderData.shippingId
  )

  if (getIngridError || !ingridData) {
    void alertService.send('Provision order | Get ingrid session', {
      blocks: [
        {
          title: 'Payload',
          content: {
            shippingId: orderData.shippingId
          }
        },
        {
          title: 'Order',
          content: orderData
        },
        {
          title: 'Error',
          content: getIngridError
        }
      ]
    })
    throw Error(getIngridError || 'getIngridSession error')
  }

  if (ingridData.session.status !== 'COMPLETE') {
    // Complete ingrid session
    const payload = {
      checkout_session_id: orderData.shippingId,
      customer:
        ingridData.session.delivery_groups[0].addresses.customer ??
        ingridData.session.delivery_groups[0].addresses.delivery_address,
      external_id: orderData.orderNumber || ''
    }

    const { data: ingridCompleteResponse, error: completeIngridError } =
      await ingridApi.checkout.completeSession(payload)

    if (completeIngridError || !ingridCompleteResponse) {
      void alertService.send('Provision order | Complete ingrid session', {
        blocks: [
          {
            title: 'Payload',
            content: payload
          },
          {
            title: 'Order',
            content: orderData
          },
          {
            title: 'Error',
            content: completeIngridError
          }
        ]
      })
      throw Error(completeIngridError || 'completeIngridSession error')
    }

    return {
      providerName: 'INGRID',
      ingridResponse: ingridCompleteResponse.session
    }
  }

  return {
    providerName: 'INGRID',
    ingridResponse: ingridData.session
  }
}
